<template>
  <div class="login-page top-bar-page page-padding-top">
    <top-bar :title="i18n.t('editPassword.title')"   @back="back"></top-bar>
    <div class="login-form">

      <div class="form-label">{{$t('editPassword.label1')}}</div>
      <div class="form-item flex-center" >
        <div class="input">
          <input :type="showOldPassword ? 'text' : 'password'" v-model="form.oldPassword" :placeholder="i18n.t('editPassword.labelPlaceholder1')">
        </div>
        <div class="adot" @click="changeShowOldPassword">
          <img :src="showOldPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

       <div class="form-label">{{$t('editPassword.label2')}}</div>
      <div class="form-item flex-center" id="passwordDom">
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" v-model="form.password" :placeholder="i18n.t('editPassword.labelPlaceholder2')">
        </div>
        <div class="adot" @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

      <div class="password-auth" v-show="showPasswordAuth">
        <div class="auth-line flex-center-start" :class="passwordAuthList.indexOf(0) > -1 ? 'green' : ''">
          <img :src="passwordAuthList.indexOf(0) > -1 ? checkedUrl2 : checkedUrl" alt="">
          <span>{{i18n.t('editPassword.passwordRule')}}</span>
        </div>
      </div>

      <div class="form-label">{{$t('editPassword.label3')}}</div>
      <div class="form-item flex-center" >
        <div class="input">
          <input :type="showPassword2 ? 'text' : 'password'"  v-model="form.password2" :placeholder="i18n.t('editPassword.labelPlaceholder3')">
        </div>
        <div class="adot" @click="changeshowPassword2">
          <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

      <div class="form-label" v-if="captchaEnabled">{{$t('editPassword.label4')}}</div>
      <div class="form-item flex-center" v-if="captchaEnabled" >
        <div class="input">
          <input type="number" inputmode="decimal"  v-model="form.code" :placeholder="i18n.t('editPassword.labelPlaceholder4')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{$t('editPassword.resend')}}({{timeCount}})</span>
          <span v-else @click="send">{{$t('editPassword.send')}}</span>
        </div>
      </div>

    </div>




    <Button class="login-btn" @click="submit" :disabled="btnDisabled">{{i18n.t(`editPassword.btn`)}}</Button>

  </div>
</template>
<script>
  import topBar from '@/components/topBar'
  import { Button, Popup } from 'vant'
  import { editPassword } from '@/api/setting'
  import { userInfo } from '@/api/user'
  import {sendAuthCode, sendAuthSms, sendCode, sendSms} from '@/api/login'
  import { getUser } from '@/utils/auth'
  import { isCaptchaEnabled } from '@/utils/captcha'
  export default {
    components: {
      Button,
      Popup,
      topBar
    },
    data() {
      return {
        form: {
          oldPassword: '',
          password: '',
          password2: '',
          code: ''
        },
        backUrl: require('../../assets/imgs/icon-back.png'),
        passwordUrl: require('../../assets/imgs/icon-password.png'),
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        checkedUrl: require('../../assets/imgs/icon-check.png'),
        checkedUrl2: require('../../assets/imgs/icon-check2.png'),
        warningUrl: require('../../assets/imgs/icon-warning.png'),
        showPassword: false,
        showPassword2: false,
        showOldPassword: false,
        isDisabled: false,
        showPasswordAuth: false,
        passwordAuthList: [],
        sendTime: '',
        userPhone: '',
        userEmail: ''
      }
    },
    computed: {
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable)
      },
      btnDisabled() {
        // 如果验证码关闭,不需要验证码
        if (!this.captchaEnabled) {
          return !(this.form.password && this.form.password2 && this.form.oldPassword)
        }
        return !(this.form.password && this.form.password2 && this.form.oldPassword && this.form.code)
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        userInfo().then(res => {
          this.userEmail = res.data.Email
          this.userPhone = res.data.Phone
        })
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      submit() {
        if (!this.form.oldPassword) {
         this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder1'))
          return
        }
        if (!this.form.password) {
          this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder2'))
          return
        }
        if (!this.form.password2) {
          this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder3'))
          return
        }

        let form = new FormData()
        form.append('OldPassword', this.form.oldPassword)
        form.append('NewPassword', this.form.password)
        form.append('ConfirmPassword', this.form.password2)
        form.append('Code', this.form.code)
        editPassword(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('editPassword.success'))
            // this.$router.push({
            //   name: 'login'
            // })
            this.back()
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      changeShowOldPassword() {
        this.showOldPassword = !this.showOldPassword
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      changePassword() {
        this.showPasswordAuth = true
        let password = this.form.password
        let result = []
        // 只检查密码长度大于等于6位
        if (password.length >= 6) {
          result.push(0)
        }

        this.passwordAuthList = result
      },
      send() {
        if (!this.captchaEnabled) {
          return
        }
        if (this.userEmail) {
          this.sendEmail()
        } else {
          this.sendPhoneSms()
        }
      },
      sendPhoneSms(){
        let form = new FormData()
        form.append('Phone', this.userPhone)
        form.append('Type', 6)
        sendAuthSms(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail(){
        let form = new FormData()
        form.append('Email', this.userEmail)
        form.append('Type', 6)
        sendAuthCode(form).then(res => {
          if (res.code == 0) {
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
    },
}
</script>
